var deDE = {
  locale: 'de_DE',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Juni', 'Juli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'],
    monthList: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Juni', 'Juli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'],
    shortDayList: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
    dayList: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
    shortestDayList: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
  },
  'dynamic-date': {
    day: 'Tag',
    week: 'Woche',
    month: 'Monat',
    quarter: 'Quartal',
    year: 'Jahr',
    before: 'vor ${value}${unit}'
  },
  'auto-complete.empty': 'Keine Daten',
  'select.selected-count': 'Ausgewählte ${count}',
  'date-time-picker.date': 'Datum auswählen',
  'image-view.zoom-out': 'Verkleinern',
  'input.placeholder': 'Bitte geben Sie ein',
  'empty.text': 'Keine Daten',
  'date-picker.cancel': 'Abbrechen',
  'date-picker.end': 'Endzeit',
  'cascader.empty': 'Keine Daten',
  'upload.drop': 'Dateien hierher ziehen oder',
  'color.custom': 'Farbe anpassen',
  'cascader.titles': ['Stufe 1', 'Stufe 2', 'Stufe 3', 'Stufe 4', 'Stufe 5', 'Stufe 6', 'Stufe 7', 'Stufe 8'],
  'date-comparison.error-target': 'Wählen Sie die Endzeit für den Vergleich aus',
  'transfer.empty': 'Keine Daten',
  'select.search.placeholder': 'Bitte geben Sie ein',
  'upload.click': 'Klicken Sie zum Hochladen',
  'date-time-picker.placeholder': 'Bitte geben Sie ein',
  'pager.jump': 'Weiterleiten',
  'tree-select.placeholder': 'Bitte geben Sie ein',
  'dynamic-date.interval': 'Intervall',
  'modal.cancel': 'Abbrechen',
  'image-view.rotate': 'Drehen',
  'tabs.more': 'Mehr',
  'popover.ok': 'Bestätigen',
  'transfer.placeholder': 'Bitte geben Sie ein',
  'date.month': 'Monat',
  'select.selected': 'Ausgewählt',
  'popover.cancel': 'Abbrechen',
  'image-view.prev': 'Vorher',
  'table.emptyText': 'Keine Daten',
  'date-time-picker.ok': 'Bestätigen',
  'table.filter.confirm': 'Bestätigen',
  'tree-select.empty': 'Keine Daten',
  'dynamic-date.fixed-date': 'Festes Datum',
  'date-comparison.compare': 'Vergleichen',
  'auto-complete.placeholder': 'Bitte geben Sie ein',
  'time-picker.placeholder': 'Zeit auswählen',
  'date.month-first': false,
  'select.clear': 'Lƒöschen',
  'date.year': 'Jahr ${year}',
  'date-comparison.yoy': 'Dieser Zeitraum im vergangenen Jahr',
  'image-view.zoom-to-origin': 'Ursprung',
  'schedule.title': 'Datum / Uhrzeit',
  'schedule.clear': 'Löschen',
  'date-time-picker.end': 'Wählen Sie Enddatum und Uhrzeit aus',
  'dynamic-date.customize': 'Anpassen',
  'date-picker.apply': 'Anwenden',
  'schedule.selected': 'Ausgewählte Zeit',
  'dynamic-date.dynamic-date': 'Dynamisches Datum',
  'select.placeholder': 'Bitte auswählen',
  'schedule.separator': ',',
  'cascader.search': 'Bitte geben Sie ein',
  'date-picker.invalid-range': 'Der ausgewählte Zeitbereich überschreitet den auswählbaren Bereich. Bitte wählen Sie einen gültigen aus.',
  'dynamic-date.date-preview': 'Datumsvorschau',
  'select.empty': 'Keine Daten',
  'image-view.next': 'Weiter',
  'date-time-picker.now': 'Jetzt',
  'date-time-picker.time': 'Zeit auswählen',
  'tree.empty': 'Keine Daten',
  'pager.total': '${total} Datensätze insgesamt',
  'image-view.zoom-in': 'Vergrößern',
  'date-picker.placeholder': 'Datum auswählen',
  'textarea.placeholder': 'Bitte geben Sie ein',
  'date.week': 'Woche',
  'pager.size': '${count} Datensätze / Seite',
  'modal.ok': 'Bestätigen',
  'date-picker.start': 'Startzeit',
  'table.filter.reset': 'Zurücksetzen',
  'image-view.zoom-to-fit': 'Anpassen',
  'pager.page.placeholder': 'Bitte geben Sie ein',
  'select.select-all': 'Alle auswählen',
  'list-viewer.empty': 'Keine Daten',
  'date-comparison.compare-text': 'VS',
  'transfer.source': 'Quellliste',
  'date-time-picker.start': 'Wählen Sie Startdatum und Uhrzeit',
  'date-time-picker-panel.start': 'Startdatum',
  'date-time-picker-panel.end': 'Endtermin',
  'date-comparison.error-source': 'Wählen Sie die Startzeit für den Vergleich',
  'upload.error.overflow-count': 'Die maximale Anzahl von Dateien wurde überschritten',
  'date-comparison.placeholder': 'Startzeit - Endzeit',
  'time-range-picker.placeholder': 'Startzeit - Endzeit',
  'date-comparison.mom': 'Im Vergleich zum vorherigen Zeitraum',
  'transfer.target': 'Zielliste',
  table: {
    selectionMenu: {
      selectCurrent: 'Select Current',
      selectAll: 'Select All',
      unselectCurrent: 'Unselect Current',
      unselectAll: 'Unselect All'
    }
  }
};
export default deDE;